import { api } from '../impl/api-v1';

api.hello.mock(async ({ hello }) => {
  return {
    world: hello,
  };
});
